import { render, staticRenderFns } from "./BroadCasterProductList.vue?vue&type=template&id=13a961b1&"
import script from "./BroadCasterProductList.vue?vue&type=script&lang=js&"
export * from "./BroadCasterProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports